export default __webpack_public_path__ + "static/media/movipack_feature4hover.aa632697.svg";